import snakeCase from 'lodash/snakeCase';

export default function getNewsboard(prefix) {
  if (/^localhost$|^[^.]*dashboard\.|^[^.]*news-form\./.test(prefix)) {
    return 'FASHIONUNITED_IE';
  }

  return snakeCase(prefix).toUpperCase();
}
